import React from 'react'
import { Container, Card, CardBody, CardHeader,Row, Col } from 'reactstrap'
import ProfileIcon from 'assets/qualified_icon.png'
import BadgeYellow from 'assets/badge_icon_1.svg'
import BadgePink from 'assets/badge_icon_2.svg'
import PercentageDekstop from 'assets/percentage_d.svg'
import Discount from 'assets/Discount.svg'
import IacstIcon from 'assets/iacst_icon_anthe.png'
import EarlyBenefits from '../EarlyBenefits/EarlyBenefits'
import NearestBranch from '../EarlyBenefits/NearestBranch'
import CONFIG from '../../../config'
import Prospectus from '../../../assets/prospectus.pdf'
import { TERMS_AND_CONDITIONS } from 'constants/externalLinks'
import {trackWebEngageEvent , params as webengage_params} from '../../../utils/customWebengageEvents'
import styles from './Nonqualified.css'
import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  profileInfo: state?.profileData,
  dashboardInfo: state?.dashboardData
})

const NonqualifiedCard = (props) => {
  console.log(props)
  const handleTnClick = () => {
    window.open(props?.dashboardInfo?.static_data?.termsLink || TERMS_AND_CONDITIONS, '_blank')
  }

const iacstCtaWebengageEvent = () => {
    let iacstCtaParam = JSON.parse(JSON.stringify(webengage_params));
    iacstCtaParam = {
      ...iacstCtaParam,
      iacst_url: CONFIG.IACST_LANDING_PAGE
    }
    trackWebEngageEvent('Anthe_db_pr_iacst_cta',iacstCtaParam);
  };

  return (
    <div className='bg-light'>
        <Container className="p-3 pb-lg-0 pb-xl-3 mt-lg-3 mh-100 maxw-11">
            <Card className=' border-0'>
                <CardHeader className="bg-aqua-60 rounded-top border-0 py-2 px-lg-4">
                <div className="d-flex align-items-center text-align-center">
                    <p className="text-white font-size-sm-lg fw-lighter font-size-xs m-0">
                    You are NOT eligible for {props?.dashboardInfo?.static_data?.exam_type ==='AKTHE' ? "ANTHE - Kashmir" : "ANTHE"} {props?.profileInfo?.anthetwo ? "2.0" : ""} Scholarship
                    </p>
                </div>
                </CardHeader>
                <CardBody className="p-3 pt-1 p-lg-4 py-4">
                  <div className="d-lg-flex flex-nowrap col-lg-12 align-items-end justify-content-between mb-lg-3 mb-0 mt-3">
                    <div className='bg-purple-light p-3 py-2 d-flex rounded align-items-center w-lg-7 justify-content-between'><div className='d-flex'><div><img src={IacstIcon} alt="discount icon" className='pe-3 d-sm-block d-none' style={{height:"24px" , marginTop: "10px"}}/></div><div><p className=' mb-0 font-size-lg-md font-size-xs text-purple-60 fw-lighter'><span>Don’t worry, you still have iACST </span> <br /><span className="font-size-lg-md font-size-xxs fw-400" >Get an opportunity to avail <strong>upto 90% scholarship</strong></span></p></div></div><div onClick={iacstCtaWebengageEvent}><a href={CONFIG.IACST_LANDING_PAGE} target="_blank" className='text-white border rounded p-lg-2 px-lg-3 p-md-2 px-md-3 text-decoration-none fw-400 bg-purple-70 font-size-lg-sm font-size-xxs text-center d-flex applynow_btn'>Apply Now</a></div></div>
                    {/* <div><p className='text-grey font-size-xs fw-400 mb-0 d-sm-block d-none'>*Terms and conditions applicable</p></div> */}
                  </div>
                  <div>
                    {/* <p className='font-size-lg-lg font-size-sm text-grey-black fw-lighter mb-2 mt-2'>Register for course & visit branch for academic counselling and batch information</p> */}
                    <p className='font-size-lg-mds font-size-sm text-dark-grey fw-lighter mt-lg-1 mt-2'>For detailed result visit branch</p>
                  </div>
                  <div className="d-lg-flex flex-nowrap col-lg-12  align-items-end justify-content-between mb-lg-4 mb-0">
                    <div className='bg-beige p-3 py-2 d-flex rounded align-items-center w-lg-7 justify-content-between'><p className='mb-0 font-size-lg-md font-size-xs text-beige-60 fw-lighter d-flex'><img src={Discount} alt="discount icon" className='pe-3 d-sm-block d-none '/>For more scholarships and discounts download scholarship prospectus</p> <a onClick={() => trackWebEngageEvent('Anthe_db_pr_prospectus_cta', webengage_params)} href={Prospectus} download="scholarschip_prospectus" target='_blank' className='text-beige-60 border-beige-60 border rounded p-lg-2 p-1 px-lg-3 px-2 text-decoration-none fw-lighter bg-white font-size-lg-md font-size-xs'>Download</a> </div>
                    <div><p className='text-grey font-size-xs fw-400 mb-0 d-sm-block d-none cursor-pointer' onClick={handleTnClick}>*Terms and conditions applicable</p></div>
                  </div>
                  <p className='text-grey' style={{fontSize:"11px", margin:"15px 0 0 0"}}>**By viewing this result, you (or your parent/guardian, if you are under 18) hereby provide consent to AESL to contact you via phone, email, SMS, or other communication channels for the purpose of sharing information, updates, and promotional material related to our services until 31st July 2026. You have the right to withdraw your consent at any time by contacting us at <a className='text-decoration-none' href='mailto:care@aesl.in'>care@aesl.in</a>.</p>
                </CardBody>
            </Card>
        </Container>
        <div><p className='text-grey font-size-xs fw-400 mb-0 d-block d-sm-none px-3 cursor-pointer' onClick={handleTnClick}>*Terms and conditions applicable</p></div>
        <Container>
        {/* <Card className='mt-3 border-0 d-sm-block d-none mb-4'>
                <CardHeader className="bg-dark-green rounded border-0 py-3 px-5 text-white m-0 fw-lighter text-center fs-li">
                Limited Seats. Admission is on a First Come, First Serve Basis. Valid until <span className='text-yellow'>31st December 2024</span>
                </CardHeader>
        </Card> */}
        </Container>
        {/* <Card className='mt-4 border-0 d-block d-sm-none'>
                <CardHeader className="bg-dark-green rounded-0 border-0 py-3 px-5 text-white m-0 fw-lighter text-center fs-li">
                Limited Seats. Admission is on a First Come, First Serve Basis. Valid until <span className='text-yellow'>31st December 2024</span>
                </CardHeader>
        </Card> */}
        <NearestBranch/>
    </div>

  )
}

export default connect(mapStateToProps)(NonqualifiedCard)